"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PlayerForm = (function () {
    function PlayerForm() {
        this.playerForm = document.querySelector('#archivePlayerForm') || null;
        this.slider = document.querySelector('.fragment-length') || null;
        this.fragmentDate = document.querySelector('.fragment-date') || null;
        if (!PlayerForm.instance) {
            PlayerForm.instance = this;
            this.init();
        }
        else {
            throw new Error("Error: Instantiation failed: Use PlayerForm.getInstance() instead of new.");
        }
    }
    PlayerForm.getInstance = function () {
        if (!this.instance) {
            this.instance = new PlayerForm();
        }
        return this.instance;
    };
    PlayerForm.prototype.init = function () {
        if (this.playerForm) {
            this.playerForm.addEventListener("submit", this.openPlayer.bind(this));
            this.slider.addEventListener('input', this.slide.bind(this));
            this.fragmentDate.addEventListener('change', this.setTimeMaxValue.bind(this));
        }
    };
    PlayerForm.prototype.slide = function () {
        var val = this.slider.value;
        var text = val == '60' ? '1 uur' : val + (val == "1" ? ' minuut' : ' minuten');
        document.querySelector('.slider-value').innerHTML = text;
    };
    PlayerForm.prototype.pad = function (value) {
        return ("00" + value).slice(-2);
    };
    PlayerForm.prototype.buildUrl = function () {
        var time = this.playerForm.querySelector('.fragment-time').value.split(':');
        var date = this.playerForm.querySelector('.fragment-date').value.split('-');
        time[2] = time[2] || '00';
        var length = parseInt(this.playerForm.querySelector('.fragment-length').value, 10);
        date[1] = this.pad(date[1]);
        date[2] = this.pad(date[2]);
        return ["/player/archief/", date.join(''), time.join(''), length * 60].join('');
    };
    PlayerForm.prototype.setTimeMaxValue = function (e) {
        var now = new Date();
        var dateValue = new Date(e.target.value);
        var timeField = document.querySelector(".fragment-time");
        if (dateValue < now) {
            timeField.removeAttribute("max");
        }
        if (dateValue.toDateString() == now.toDateString()) {
            var currTime = this.pad(now.getHours()) + ":" + this.pad(now.getMinutes());
            timeField.setAttribute("max", currTime);
        }
    };
    PlayerForm.prototype.openPlayer = function (e) {
        e.preventDefault();
        var url = this.buildUrl();
        var playerWindow = window.open(url, "_blank", "width=380,scrollbars=1,height=" + (window.screen.height - 100));
        playerWindow.moveTo(20, 20);
    };
    return PlayerForm;
}());
exports.default = PlayerForm;
